@if (overlays$ | async; as overlays) {
  <div class="p-2 flex flex-col gap-2">
    <div>
      @for (overlay of overlays; track overlay) {
        <div class="flex gap-2 items-center justify-between">
          <span>{{overlay.title | transloco}}</span>
          <div>
            <button (click)="onMaximize(overlay)" mat-icon-button>
              <mat-icon>visibility</mat-icon>
            </button>
            <button (click)="onClose(overlay)" mat-icon-button>
              <mat-icon>delete</mat-icon>
            </button>
          </div>
        </div>
      }
    </div>
    <div class="flex items-center">
      <button (click)="onResetAll()" mat-button>
        {{'overlay.reset_all' | transloco}}
      </button>
      <button (click)="onCloseAll()" mat-button>
        {{'overlay.close_all' | transloco}}
      </button>
    </div>
  </div>
}
